import DiscussionSearch from './components/DiscussionSearch';
import DiscussionSearchSource from './components/DiscussionSearchSource';
import compat from '../common/compat';

export default {
  ...compat,
  'ui-kit/forum/DiscussionSearch': DiscussionSearch,
  'ui-kit/forum/DiscussionSearchSource': DiscussionSearchSource,
};
